var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var CurrentUser = require('lib/account/CurrentUser');
var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var BookDisplay = require("components/reading/books/BookDisplay");
var FITBAnswerBox = require("components/writing/questions/FITBAnswerBox");

var MappingControl = require("components/org/roster_upload/MappingControl");
var Spinner = require("components/utility/Spinner");
var SmartBookSearch = require("components/reading/books/SmartBookSearch");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var ValidatingInput = require("components/utility/ValidatingInput");

import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

require("writing/questions/text_questions_page.scss")

@connect(
	(state, props) => {
		var textID = props.match.params.text_id;
		if (textID) {
			var questions = WritingSelectors.questions({
				state, filters: {
					text_id: textID, type: "fill-in-the-blank-question"
				}
			});
		}
		var pageLoading = WritingSelectors.isLoadingQuestions({ state });
		var buttonLoading = WritingSelectors.isLoadingQuestions({ state, key: "create" });
		return {
			questions, pageLoading, buttonLoading
		}
	},
	(dispatch, props) => {
		var textID = props.match.params.text_id;
		var userID = CurrentUser.get().id;

		return {
			populateData: (newTextID) => {
				var useTextID = newTextID || textID;
				if (useTextID) {
					var filters = {
						text_id: useTextID,
						types: "fill-in-the-blank-question",
						any_user_id: true,
						check_linked_user_id: CurrentUser.get().id,
					}
					return dispatch(WritingActions.fetchQuestions({ filters, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
				}
			},
			addQuestion: (question) => {
				question = _.extend({}, question, { linked: true, linked_count: question.linked_count + 1 })
				var query = { check_linked_user_id: userID, link_user_id: userID }
				return dispatch(WritingActions.updateQuestion({ id: question.id, update: question, query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			createQuestion: (newQuestion) => {
				var query = { check_linked_user_id: userID }
				return dispatch(WritingActions.createQuestion({ question: newQuestion, query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			removeQuestion(question) {
				question = _.extend({}, question, { linked: false, linked_count: question.linked_count - 1 })
				var query = { check_linked_user_id: userID, unlink_user_id: userID }
				return dispatch(WritingActions.updateQuestion({ id: question.id, update: question, query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			updateQuestion(updatedQuestion) {
				var query = { check_linked_user_id: userID }
				return dispatch(WritingActions.updateQuestion({ id: updatedQuestion.id, update: updatedQuestion, query, embeds: ["question.answer_options,question.linked,question.linked_count"] }));
			},
			deleteQuestion(questionID) {
				return dispatch(WritingActions.deleteQuestion({ id: questionID }))
			}
		}
	}
)
@providePopulateData()
class TextQuestionsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			addingQuestion: false, loading: false, editingID: null, currentView: ACTIVE_QUESTIONS,
			newAnswerOptions: [], editAnswerOptions: []
		}
	}

	textID() {
		return this.props.match.params.text_id;
	}

	onBookSelect(book) {
		var textID = book.text_id;
		$wr.redirect("/questions/" + textID );
		this.props.populateData(textID);
	}

	goBack() {
		$wr.redirect("/questions/");
	}

	toggleAddingQuestion(e) {
		$wr.nope(e)
		this.setState({ addingQuestion: !this.state.addingQuestion });
	}

	toggleEditingQuestion(questionID) {
		if (this.state.editingID == questionID) {
			this.setState({ editingID: null });
		} else {
			var editAnswerOptions = _.findWhere(
				this.props.questions, { id: questionID }
			).answer_options.concat("");
			this.setState({ editingID: questionID, editAnswerOptions });
		}
	}

	addQuestion(question) {
		this.props.addQuestion(question);
		setTimeout(() => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Success!", text: "You successfully added a question.", icon: "ok-sign" });	
		}, 1000)
	}

	removeQuestion(question) {
		if (confirm("Are you sure you want to remove this question?")) {
			this.props.removeQuestion(question);
			setTimeout(() => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "You successfully removed a question.", icon: "ok-sign" });	
			}, 1000)
		}
	}

	deleteQuestion(questionID) {
		if (confirm("Are you sure you want to delete this question?")) {
			this.props.deleteQuestion(questionID);
			var text = "You successfully deleted a question."
			setTimeout(() => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Question Deleted", text: text, icon: "trash" })
			}, 1000)
		}
	}

	newAnswerOps() {
		return _.reject(this.state.newAnswerOptions.map(x => x.trim()), _.isEmpty);
	}
	editAnswerOps() {
		return _.reject(this.state.editAnswerOptions.map(x => x.trim()), _.isEmpty);
	}

	validateForm(edit) {
		if (edit) {
			return this.refs.editedQuestionBody.validate() && (this.editAnswerOps().length > 0);
		} else {
			return this.refs.questionBody.validate() && (this.newAnswerOps().length > 0);
		}
	}

	submitNewQuestion(e) {
		$wr.nope(e)
		if (!this.validateForm()) {
			return;
		}
		this.setState({ loading: true });
		var question = this.refs.questionBody.val();
		var answers = this.newAnswerOps();

		var questionData = { body: question, text_id: this.textID(), 
			type: "fill-in-the-blank-question", user_id: CurrentUser.get().id, answer_options: answers
		}
		this.setState({ loading: false }, () => {
			this.props.createQuestion(questionData);
			this.refs.questionBody.reset();
			this.setState({ newAnswerOptions: [] });
			setTimeout(() => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "You successfully added a question.", icon: "ok-sign" });
			}, 1000)
		});
	}

	submitEditedQuestion(editedQuestion) {
		if (!this.validateForm("edit")) {
			return;
		}
		this.setState({ loading: true });
		var question = this.refs.editedQuestionBody.val();
		var answers = this.editAnswerOps();
		var questionData = { id: editedQuestion.id, body: question, answer_options: answers };
		this.setState({ loading: false }, () => {
			this.props.updateQuestion(questionData);
			this.toggleEditingQuestion(editedQuestion.id);
			setTimeout(() => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "You successfully edited a question.", icon: "ok-sign" });	
			}, 1000)
		});
	}

	onViewChange(viewKey) {
		this.setState({ currentView: viewKey })
	}

	renderWRQuestions(questions) {
		var questionsContent = _.map(questions, function(question) {
			var questionDisplay = (
				<div className="question" key={ question.id }>
					<p className="bodyContainer">{ question.body }</p>
					<p className="answersContainer">
						<span className="answersLabel">answers:</span> { (question.answer_options || []).join(", ") }
					</p>
					<p className="originTag">Selected by Whooo's Reading</p>
				</div>
			);
			return (
				<div className="questionAnswerContainer" key={ question.id }>
					{ questionDisplay }
					<span className="verticalDivider"></span>
				</div>
			)
		}.bind(this));
		return questionsContent;
	}

	renderUserQuestions(questions) {
		var questionsContent = _.map(questions, function(question) {
			if (this.state.editingID == question.id) {
				var editControls = (
					<div className="controls">
						<LoadingButton className="btn buttonSuccess" loading={ this.props.buttonLoading }
							text="Save" onClick={ this.submitEditedQuestion.bind(this, question) } />
						<a className="cancelLink" 
							onClick={ this.toggleEditingQuestion.bind(this, question.id) }>
							Cancel
						</a>
					</div>
				)
				var questionDisplay = (
					<div key={ question.id } className="editingContainer">
						<form className="editQuestionForm" onSubmit={ $wr.nope }>
							<label>Question</label>
							<ValidatingInput type="textarea" ref="editedQuestionBody"
								validators={ [ValidatingInput.Validators.PRESENT, ValidatingInput.Validators.FITB] }
								inputClassName="form-control"
								defaultValue={ question.body }
								placeholder="Your question..." />
							<label>Answers</label>

							<FITBAnswerBox answers={ this.state.editAnswerOptions }
								updateAnswers={ (editAnswerOptions) => this.setState({ editAnswerOptions }) } />

							{ editControls }
						</form>
					</div>
				);
			} else {
				if (question.linked_count  == 1) {
					var questionControls = (
						<div className="questionControls">
							<a className="editLink" onClick={ this.toggleEditingQuestion.bind(this, question.id) }>
								Edit
							</a>
							<a className="controlLink" onClick={ this.deleteQuestion.bind(this, question.id) }>
								Delete
							</a>
						</div>
					)
					var originTag = (
						<p className="originTag">Your question </p>
					)
				} else {
					var originTag = (
						<p className="originTag">Selected by { question.linked_count } { $wr.pluralize("teacher", question.linked_count) } </p>
					)
					var questionControls = (
						<div className="questionControls">
							<a onClick={ this.removeQuestion.bind(this, question) }>
								Remove
							</a>
						</div>
					)
				}
				var questionDisplay = (
					<div className="question">
						<p className="bodyContainer">{ question.body }</p>
						<p className="answersContainer">
							<span className="answersLabel">answers:</span> { (question.answer_options || []).join(", ") }
						</p>
						{ questionControls }
						{ originTag }
					</div>
				);
			}
			return (
				<div className="questionAnswerContainer" key={ question.id }>
					{ questionDisplay }
					<span className="verticalDivider"></span>
				</div>
			)
		}.bind(this));
		return questionsContent;
	}

	renderInactiveQuestions(questions) {
		var questionsContent = _.map(questions, function(question) {
			var questionControls = (
				<div className="questionControls">
					<a className="controlLink" onClick={ this.addQuestion.bind(this, question) }>
						Add
					</a>
				</div>
			)
			var originTag = (
				<p className="originTag">Selected by { question.linked_count } { $wr.pluralize("teacher", question.linked_count) } </p>
			)
			var questionDisplay = (
				<div className="question" key={ question.id }>
					<p className="bodyContainer">{ question.body }</p>
					<p className="answersContainer">
						<span className="answersLabel">answers:</span> { (question.answer_options || []).join(", ") }
					</p>
					{ questionControls }
					{ originTag }
				</div>
			);
			return (
				<div className="questionAnswerContainer" key={ question.id }>
					{ questionDisplay }
					<span className="verticalDivider"></span>
				</div>
			)
		}.bind(this));
		return questionsContent;
	}

	render() {
		// Questions created by WR
		var wrQuestions = _.select(this.props.questions, function(question) {
				return question.user_id == null
		}.bind(this));

		// Questions created by Current User
		var userQuestions = _.select(this.props.questions, function(question) {
			return question.linked;
		}.bind(this));


		// Questions created by other teachers
		var inactiveQuestions = _.select(this.props.questions, function(question) {
			return question.user_id && !question.linked;
		}.bind(this))

		var questionsCount = " (" + (wrQuestions.length + userQuestions.length) + ")";
		var activeQuestionsText = "My Questions" + questionsCount;
		var inactiveQuestionsCount = " (" + inactiveQuestions.length + ")";
		var inactiveQuestionsText = "Teacher Questions" + inactiveQuestionsCount;

		var toggleOptions = [
			{ key: ACTIVE_QUESTIONS, text: activeQuestionsText },
			{ key: INACTIVE_QUESTIONS, text: inactiveQuestionsText } // Question Pool
		];

		var displayToggleOptions = (
			<div className="hideOnPrint">
				<DisplayToggleControl options={ toggleOptions }
					onChange={ this.onViewChange } activeOptionKey={ this.state.currentView } />
			</div>
		);

		if (this.textID()) {
			if (this.props.pageLoading) {
				var content = (
					<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
				);
			} else {
				if (this.state.currentView == ACTIVE_QUESTIONS) {
					var wrQuestionsContent = this.renderWRQuestions(wrQuestions);
					var questionsContent = this.renderUserQuestions(userQuestions);
					var placeholderText = "Write some questions here PLEASE....."
					var newQuestionContent = (
						<div>
							<form className="newQuestionForm">
								<div className="inputContainer">
									<p className="inputLabel">Question</p>
									<ValidatingInput type="textarea" ref="questionBody" className="questionBodyInput"
										validators={ [ValidatingInput.Validators.PRESENT, ValidatingInput.Validators.FITB] }
										inputClassName="form-control"
										placeholder="Your question..." />
									<p className="instructionText">
										Questions should look like this: "Sam-I-Am wanted his friend to try ____" (4 underscores).</p>	
								</div>
								<div className="inputContainer">
									<p className="inputLabel">Answers</p>

									<FITBAnswerBox answers={ this.state.newAnswerOptions }
										updateAnswers={ (newAnswerOptions) => this.setState({ newAnswerOptions }) } />

									<p className="instructionText">Answers should look like this: "eggs, ham." (Separate each answer with a comma or line return.)</p>	
								</div>
								<div className="controls">
									<LoadingButton className="btn buttonSuccess" loading={ this.props.buttonLoading }
										text="Save" onClick={ this.submitNewQuestion } />
								</div>
							</form>
						</div>
					);

					if (wrQuestions.length == 0 && userQuestions.length == 0) {
						if (inactiveQuestions.length > 0) {
							var otherTeacherText = "or select questions written by other teachers";
						}

						var text = (
							<div className="text">
								<p>
									There aren't any text-specific fill-in-the-blank questions for this book yet.
									Students can still take quizzes for it, but scores
									won't be as accurate.
								</p>
								<p>
									You can add your own questions below { otherTeacherText } to
									improve quizzes and challenge your students.
								</p>
							</div>
						);

					}

				} else {
					if (inactiveQuestions.length == 0) {
						var text = (
							<div className="text">
								<p>This book doesn't have any questions from other teachers yet.</p>
							</div>
						)
					} else {
						var text = (
							<div className="text">
								<p>Select questions written by other teachers to add them to your students' quizzes.</p>
							</div>
						)						
					}

					
					var questionsContent = this.renderInactiveQuestions(inactiveQuestions);
				}
				var content = (
					<div className="contentContainer">
						<a className="backLink" onClick={ this.goBack }>Back to Question Search</a>
						{ displayToggleOptions }
						<BookDisplay textID={ this.textID() } />
						<div className="textQuestionsContainer">
							{ text }
							<div>
								{ wrQuestionsContent }
								{ questionsContent }
								{ newQuestionContent }
							</div>
						</div>  
					</div>
				)
			}
		} else {
			var content = (
				<div>
					<p>
						Find a book to view all text-specific fill-in-the-blank quiz questions, select new ones written by teachers, or add your own.
					</p>
					<div className="bookSearchBox">
						<SmartBookSearch onBookSelect={ this.onBookSelect } preventManual
							selectedBook={ this.state.selectedBook } />
					</div>
				</div>
			)
		}
		return (
			<div className="container textQuestionsPage">
				<header className="pageHeader">
					<h1>Question Search</h1>
				</header>
				{ content }
			</div>
		);
	}
}

var ACTIVE_QUESTIONS = "owned questions";
var INACTIVE_QUESTIONS = "non owned questions";
var WR_QUESTIONS = "wr"

TextQuestionsPage.propTypes = PageStrictPropTypes({
	populateData: PropTypes.func,
	loading: PropTypes.bool
});

module.exports = TextQuestionsPage;



// WEBPACK FOOTER //
// ./modules/components/writing/questions/TextQuestionsPage.js